module.exports = __webpack_public_path__ + "media/green-circle.8d79e003.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/simple/green-circle.svg
// module id = 890
// module chunks = 0